//back to this
import "flag-icons/css/flag-icons.min.css";
import { useEffect } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import BookingResult from "./components/BookingResult";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Adminscreen from "./screens/admin";
import AddOnServiceScreen from "./screens/admin/addOnService";
import AddRoomScreen from "./screens/admin/addRoom";
import AnalyticsScreen from "./screens/admin/analytics";
import BookingListScreen from "./screens/admin/bookingList";
import ChannelManagerScreen from "./screens/admin/channelManager";
import DashboardScreen from "./screens/admin/dashboard";
import GeneralInfoScreen from "./screens/admin/generalInfo";
import HotelRulesScreen from "./screens/admin/hotelRules";
import PaymentMethodScreen from "./screens/admin/paymentMethod";
import PoliciesScreen from "./screens/admin/policies";
import PromotionManagementScreen from "./screens/admin/promotionManagement";
import RatePlanManagementScreen from "./screens/admin/ratePlanManagement";
import RetrieveCardInputScreen from "./screens/admin/retrieveCardInput";
import ReviewManagementScreen from "./screens/admin/reviewManagement";
import RoomingListScreen from "./screens/admin/roomingList";
import RoomManagementScreen from "./screens/admin/roomManagement";
import UsersScreen from "./screens/admin/users";
import Bookingscreen from "./screens/users/booking";
import ConfirmationScreen from "./screens/users/confirmation";
import DecryptCardDetailsScreen from "./screens/users/decryptCard";
import Homescreen from "./screens/users/home";
import LoginScreen from "./screens/users/login";
import MyBookingScreen from "./screens/users/mybooking";
import Profilescreen from "./screens/users/profile";
import Registerscreen from "./screens/users/register";
import VerifyOtpScreen from "./screens/users/verifyOtp";

import { BookingProvider } from "./components/BookingContext";
import { CurrencyProvider } from "./components/CurrencyContext";

import "./i18n";

import axios from "axios";
import { BrandingProvider } from "./components/BrandingContext";
import { HotelInfoProvider } from "./components/HotelInfoContext";
import BrandingScreen from "./screens/admin/branding";

function App() {
  useEffect(() => {
    const tenantId =
      window.location.hostname.split(".")[0] !== "localhost"
        ? window.location.hostname.split(".")[0]
        : "defaultTenant"; // Resolve tenant dynamically
    if (typeof document === "undefined" || !tenantId) return;

    // Fetch tenant-specific meta info
    axios
      .get("/api/hotelInfo/hotel-info", {
        headers: {
          "X-Tenant-ID": tenantId,
        },
      })
      .then((response) => {
        const hotelInfo = response.data;

        // Update document title
        document.title = hotelInfo.hotelName || "Welcome to our hotel";

        // Update favicon dynamically
        const favicon = document.querySelector('link[rel="icon"]');
        if (favicon) {
          favicon.href = hotelInfo.favicon || "/favicon.ico"; // Default favicon
        } else {
          const newFavicon = document.createElement("link");
          newFavicon.rel = "icon";
          newFavicon.href = hotelInfo.favicon || "/favicon.ico";
          document.head.appendChild(newFavicon);
        }

        // Update meta description
        const metaDescription = document.querySelector(
          'meta[name="description"]'
        );
        if (metaDescription) {
          metaDescription.content =
            hotelInfo.description || "Welcome to our hotel";
        }

        // Set Open Graph tags
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) {
          ogTitle.content = hotelInfo.hotelName || "Welcome to our hotel";
        }

        const ogDescription = document.querySelector(
          'meta[property="og:description"]'
        );
        if (ogDescription) {
          ogDescription.content =
            hotelInfo.description || "Welcome to our hotel";
        }

        const ogImage = document.querySelector('meta[property="og:image"]');
        if (ogImage) {
          ogImage.content = hotelInfo.featureImage || "/default-image.jpg";
        }
      })
      .catch((error) => {
        console.error("Error fetching tenant data:", error);
      });

    // Branding is loaded by BrandingProvider
  }, []);

  return (
    <BookingProvider>
      <CurrencyProvider>
        <BrandingProvider>
          <HotelInfoProvider>
            <Router>
              <div className="App">
                <Navbar />
                <Routes>
                  <Route path="/" element={<Homescreen />} />
                  <Route path="/booking" element={<Bookingscreen />} />
                  <Route path="/register" element={<Registerscreen />} />
                  <Route path="/login" element={<LoginScreen />} />
                  <Route path="/verify-otp" element={<VerifyOtpScreen />} />
                  <Route path="/profile" element={<Profilescreen />} />
                  <Route
                    path="/decrypt-card/:bookingId"
                    element={<DecryptCardDetailsScreen />}
                  />
                  <Route path="/booking-result" element={<BookingResult />} />
                  <Route
                    path="/confirmation"
                    element={<ConfirmationScreen />}
                  />
                  <Route path="/mybooking" element={<MyBookingScreen />} />

                  {/* Admin routes */}
                  <Route path="/admin" element={<Adminscreen />}>
                    <Route
                      path="/admin/roommanagement"
                      element={<RoomManagementScreen />}
                    />
                    <Route
                      path="/admin/dashboard"
                      element={<DashboardScreen />}
                    />
                    <Route
                      path="/admin/rateplans"
                      element={<RatePlanManagementScreen />}
                    />
                    <Route
                      path="/admin/policies"
                      element={<PoliciesScreen />}
                    />
                    <Route
                      path="/admin/retrieve-card-input"
                      element={<RetrieveCardInputScreen />}
                    />
                    <Route
                      path="/admin/roomreview"
                      element={<ReviewManagementScreen />}
                    />
                    <Route
                      path="/admin/generalinfo"
                      element={<GeneralInfoScreen />}
                    />
                    <Route
                      path="/admin/payment-method"
                      element={<PaymentMethodScreen />}
                    />
                    <Route
                      path="/admin/promotions"
                      element={<PromotionManagementScreen />}
                    />
                    <Route
                      path="/admin/bookinglist"
                      element={<BookingListScreen />}
                    />
                    <Route
                      path="/admin/roominglist"
                      element={<RoomingListScreen />}
                    />
                    <Route path="/admin/addroom" element={<AddRoomScreen />} />
                    <Route path="/admin/users" element={<UsersScreen />} />
                    <Route
                      path="/admin/addonservices"
                      element={<AddOnServiceScreen />}
                    />
                    <Route
                      path="/admin/branding"
                      element={<BrandingScreen />}
                    />
                    <Route
                      path="/admin/hotelrules"
                      element={<HotelRulesScreen />}
                    />
                    <Route
                      path="/admin/analytics"
                      element={<AnalyticsScreen />}
                    />
                    <Route
                      path="/admin/channelmanager"
                      element={<ChannelManagerScreen />}
                    />
                  </Route>
                </Routes>
                <Footer />
              </div>
            </Router>
          </HotelInfoProvider>
        </BrandingProvider>
      </CurrencyProvider>
    </BookingProvider>
  );
}

export default App;
